import { format, isValid, parseISO } from 'date-fns';

export const formatDateToPtBr = (date: string | Date): string => {
  if (typeof date === 'string') {
    const parsedDate = parseISO(date);

    return isValid(parsedDate) ? format(parsedDate, 'dd/MM/yyyy') : '--';
  }

  return isValid(date) ? format(date, 'dd/MM/yyyy') : '--';
};
